export enum LayoutType {
  Login,
  Error,
  Full
}
